import React from 'react';
import {renderInto} from './reactRoot';
import _ from 'lodash';
import Select from 'react-select';
import {fixLangFlag} from './utils';

class LocaleSelectField {
    static initNode(domContainer) {
        if (!domContainer || domContainer.dataset.localeSelectInitialized === 'true') {
            return;
        }
        domContainer.dataset.localeSelectInitialized = 'true';

        const field = $(domContainer);
        let options = field.data('options');
        let valueFromData = field.data('value');
        let defaultValue = null;

        _.forOwn(options, function (locale, key) {
            if (locale.value === valueFromData) {
                defaultValue = locale;
            }
            options[key].label = <div className='react-select__single-value--row'>
                <span className={'iti-flag lang-flag lang-flag--' + (fixLangFlag(locale.value)) + ' ' + (fixLangFlag(locale.value))}></span>{locale.label}
            </div>;
        });

        if (!defaultValue) {
            // Profile/organization locale selects keep an "auto" option to fall back to.
            // Collections without a saved value (e.g. a freshly added translation row) are left
            // unselected instead of silently defaulting to the first language in the list — otherwise
            // adding a translation would look like the user picked that language, causing spurious
            // duplicate-locale warnings against an existing translation in the same language.
            defaultValue = _.find(options, (locale) => locale.value === 'auto') || null;
        }

        // Keep the current value on the container so non-react code (duplicate/validation checks) can read it.
        domContainer.dataset.value = defaultValue ? defaultValue.value : (valueFromData || '');

        renderInto(
            domContainer,
            <Select
                defaultValue={defaultValue}
                options={options}
                name={field.data('name')}
                id={field.data('id')}
                classNamePrefix='react-select'
                className={field.data('class')}
                onChange={(option) => {
                    domContainer.dataset.value = option ? option.value : '';
                    domContainer.dispatchEvent(new CustomEvent('localeselect:change', {bubbles: true}));
                }}
            />
        );
    }

    static initLocaleSelectField(root) {
        const scope = root || document;
        scope.querySelectorAll('.locale-select-field').forEach((node) => LocaleSelectField.initNode(node));
    }
}

LocaleSelectField.initLocaleSelectField();

// Expose so dynamically added selects (e.g. cancellation policy translation rows) can be initialised.
window.LocaleSelectField = LocaleSelectField;

export default LocaleSelectField;
